import type { SVGProps } from "react";
const SvgNumber04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="47.216pt"
    height="70.666pt"
    viewBox="32.495 -311.252 47.216 70.666"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 76.365,274.087 C 76.683,274.129 76.951,274.052 77.171,273.855 C 77.39,273.658 77.49,273.397 77.468,273.071 L 77.533,260.878 C 77.512,260.553 77.405,260.264 77.212,260.013 C 77.02,259.761 76.765,259.614 76.447,259.572 L 73.402,259.169 C 73.085,259.128 72.947,258.948 72.989,258.631 L 73.134,243.64 C 73.113,243.315 73.006,243.026 72.813,242.775 C 72.62,242.523 72.365,242.377 72.048,242.335 L 58.915,240.597 C 58.597,240.555 58.329,240.632 58.109,240.829 C 57.889,241.026 57.79,241.287 57.812,241.613 L 57.667,256.603 C 57.625,256.921 57.445,257.058 57.128,257.016 L 33.716,253.919 C 33.399,253.877 33.13,253.954 32.91,254.151 C 32.691,254.348 32.592,254.609 32.613,254.935 L 32.495,264.603 C 32.538,265.254 32.606,265.715 32.699,265.986 L 44.128,305.458 C 44.362,306.134 44.764,306.51 45.335,306.586 L 59.325,308.437 C 59.705,308.487 59.976,308.394 60.137,308.157 C 60.297,307.92 60.339,307.602 60.263,307.205 L 50.403,271.233 C 50.263,270.827 50.384,270.649 50.764,270.7 L 57.046,271.531 C 57.363,271.573 57.501,271.752 57.459,272.07 L 57.422,280.393 C 57.443,280.718 57.55,281.007 57.743,281.258 C 57.935,281.51 58.19,281.656 58.508,281.698 L 71.641,283.436 C 71.958,283.478 72.227,283.401 72.447,283.204 C 72.666,283.007 72.766,282.746 72.744,282.42 L 72.781,274.097 C 72.823,273.78 73.003,273.642 73.32,273.684 L 76.365,274.087 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 78.543,276.889 C 78.861,276.931 79.129,276.854 79.349,276.657 C 79.568,276.46 79.668,276.199 79.646,275.873 L 79.711,263.68 C 79.69,263.355 79.583,263.066 79.39,262.815 C 79.198,262.563 78.943,262.416 78.625,262.374 L 75.58,261.971 C 75.263,261.93 75.125,261.75 75.167,261.433 L 75.312,246.442 C 75.291,246.117 75.184,245.828 74.991,245.577 C 74.798,245.325 74.543,245.179 74.226,245.137 L 61.093,243.399 C 60.775,243.357 60.507,243.434 60.287,243.631 C 60.067,243.828 59.968,244.089 59.99,244.415 L 59.845,259.405 C 59.803,259.723 59.623,259.86 59.306,259.818 L 35.894,256.721 C 35.577,256.679 35.308,256.756 35.088,256.953 C 34.869,257.15 34.77,257.411 34.791,257.737 L 34.673,267.405 C 34.716,268.056 34.784,268.517 34.877,268.788 L 46.306,308.26 C 46.54,308.936 46.942,309.312 47.513,309.388 L 61.503,311.239 C 61.883,311.289 62.154,311.196 62.315,310.959 C 62.475,310.722 62.517,310.404 62.441,310.007 L 52.581,274.035 C 52.441,273.629 52.562,273.451 52.942,273.502 L 59.224,274.333 C 59.541,274.375 59.679,274.554 59.637,274.872 L 59.6,283.195 C 59.621,283.52 59.728,283.809 59.921,284.06 C 60.113,284.312 60.368,284.458 60.686,284.5 L 73.819,286.238 C 74.136,286.28 74.405,286.203 74.625,286.006 C 74.844,285.809 74.944,285.548 74.922,285.222 L 74.959,276.899 C 75.001,276.582 75.181,276.444 75.498,276.486 L 78.543,276.889 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber04;
